import React, { useEffect, useRef } from 'react';
import { Group, Vector3 } from 'three';
import { useThree } from 'react-three-fiber';
import Stick from '../../../components/xr/stick';
import { SYNC_STICK } from '../../../common/constants/socket-events';
import { useSocket } from '../../../hooks';

const PresenterStick = () => {
  const { gl, camera } = useThree();
  const Socket = useSocket();
  const stick = useRef<Group>(null);

  useEffect(() => {
    if (!Socket) return;

    const vector = new Vector3();
    const canvas = gl.domElement;

    const mouseMoveHandler = (evt: MouseEvent) => {
      vector.set((evt.clientX / window.innerWidth) * 2 - 1, -(evt.clientY / window.innerHeight) * 2 + 1, 0.5);

      vector.unproject(camera);

      vector.sub(camera.position).normalize();

      // emit event here

      Socket.emit(SYNC_STICK, {
        value: vector,
      });

      if (stick.current) {
        stick.current.position.copy(vector);
        stick.current.lookAt(camera.position);
      }
    };

    canvas.addEventListener('mousemove', mouseMoveHandler);

    return () => {
      canvas.removeEventListener('mousemove', mouseMoveHandler);
    };
  }, [Socket, camera, gl.domElement]);

  return <Stick ref={stick} />;
};

export default PresenterStick;
